import { ActionTree } from 'vuex';
import { IHttpState } from '@/store/modules/http/state';
import { MutationTypes } from './mutation-types';

export default {
  [MutationTypes.SET_IS_LOADING]({ commit, state }, value: IHttpState) {
    commit(MutationTypes.SET_IS_LOADING, value);

    return state;
  },
  [MutationTypes.GET_IS_LOADING]({ commit }, value: IHttpState) {
    commit(MutationTypes.GET_IS_LOADING, value);
  },
} as ActionTree<IHttpState, any>;
